import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';

export interface DeleteViewDialogData {
  savedViews: any[];
  entityType: string;
}

@Component({
  selector: 'app-delete-view-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatListModule,
    MatIconModule
  ],
  template: `
    <h2 mat-dialog-title>Delete Saved Views</h2>
    <mat-dialog-content>
      @if (data.savedViews && data.savedViews.length > 0) {
        <p class="warning-text">Select a view to delete. This action cannot be undone.</p>
        <mat-list>
          @for (view of data.savedViews; track view.name) {
            <mat-list-item>
              <div class="view-item">
                <span class="view-name">{{ view.name || 'Unnamed View' }}</span>
                <button mat-icon-button color="warn" (click)="deleteView(view)" aria-label="Delete view">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </mat-list-item>
          }
        </mat-list>
      } @else {
        <p class="no-views">No saved views found. Nothing to delete.</p>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="close()">Close</button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content {
      min-width: 400px;
      max-height: 500px;
      overflow-y: auto;
    }

    .warning-text {
      padding: 8px 16px;
      background-color: #fff3cd;
      border: 1px solid #ffc107;
      border-radius: 4px;
      color: #856404;
      margin-bottom: 16px;
    }

    .view-item {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 16px;
    }

    .view-name {
      flex: 1;
    }

    .no-views {
      padding: 24px;
      text-align: center;
      color: #666;
    }

    mat-list-item {
      border-bottom: 1px solid #e0e0e0;
    }

    mat-list-item:hover {
      background-color: #f5f5f5;
    }
  `]
})
export class DeleteViewDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DeleteViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteViewDialogData
  ) {}

  deleteView(view: any): void {
    // Return the view name to delete
    this.dialogRef.close(view.name);
  }

  close(): void {
    this.dialogRef.close();
  }
}
